import { toWorkspacePath } from "@/features/Workspaces/workspaceRoutes";
// Import of the module

import { ExternalLink } from "@/components/ExternalLink";
import i18n from "@/i18n";
import { Link } from "@heroui/link";
import { ColumnDef } from "@tanstack/react-table";
import { categoryMap } from "./config";

export enum OwnerType {
  ANY = "Any",
  FACTOR = "Factor",
  FINANCIAL_INDICATOR = "FinancialIndicator",
  ISSUER = "Issuer",
  LINK = "Link",
  STRATEGY = "Strategy",
}

// Type of the fields in the table

export type LinkType = {
  id: number;
  strategy_from_id: number;
  strategy_from_name?: string;
  strategy_to_id: number;
  strategy_to_name?: string;
  derivative_to_id?: number;
  derivative_to_name?: string;
  category?: number;
  code?: string;
  code2?: string;
};

// Definition of the columns

export const links_columns: ColumnDef<LinkType>[] = [
  {
    accessorKey: "strategy_from_name",
    header: "Strategy From",
    cell: ({ row }) => {
      const strategyFromId = row.original.strategy_from_id;
      const strategyFromName = row.original.strategy_from_name;
      return strategyFromId ? (
        <Link
          href={toWorkspacePath(
            `/admin/qtl - referential/strategies/${strategyFromId}`,
          )}
          className="text-xs"
          underline="hover"
        >
          {strategyFromName || `Strategy ${strategyFromId}`}
        </Link>
      ) : (
        ""
      );
    },
  },
  {
    accessorKey: "strategy_to_name",
    header: "Strategy To",
    cell: ({ row }) => {
      const strategyToId = row.original.strategy_to_id;
      const strategyToName = row.original.strategy_to_name;
      return strategyToId ? (
        <Link
          href={toWorkspacePath(
            `/admin/qtl - referential/strategies/${strategyToId}`,
          )}
          className="text-xs"
          underline="hover"
        >
          {strategyToName || `Strategy ${strategyToId}`}
        </Link>
      ) : (
        ""
      );
    },
  },
  {
    accessorKey: "derivative_to_name",
    header: "Derivative To",
    cell: ({ row }) => {
      const derivativeToId = row.original.derivative_to_id;
      const derivativeToName = row.original.derivative_to_name;
      return derivativeToId ? (
        <Link
          href={toWorkspacePath(
            `/admin/qtl - referential/strategies/${derivativeToId}`,
          )}
          className="text-xs"
          underline="hover"
        >
          {derivativeToName || `Strategy ${derivativeToId}`}
        </Link>
      ) : (
        ""
      );
    },
  },
  {
    accessorKey: "category",
    header: "Category",
    cell: ({ row }) => {
      const categoryValue = row.original.category;
      return categoryValue !== null && categoryValue !== undefined
        ? categoryMap[categoryValue] || `Unknown (${categoryValue})`
        : "";
    },
  },
  {
    accessorKey: "code",
    header: "Code",
    cell: ({ row }) => row.original.code || "",
  },
  {
    accessorKey: "code2",
    header: "Code2",
    cell: ({ row }) => row.original.code2 || "",
  },
  {
    id: "actions",
    header: () => (
      <div className="text-right">
        {i18n.t("links.columns.actions", {
          ns: "tables",
          defaultValue: "Actions",
        })}
      </div>
    ),
    cell: ({ row }) => {
      const id = row.original.id;
      return (
        <div className="flex justify-end space-x-2">
          <ExternalLink
            href={toWorkspacePath(
              "/admin/qtl - dynamic data/strategy_time_series",
            )}
            queryParams={{
              owner_id_equals: id.toString(),
              owner_type_contains: OwnerType.LINK,
            }}
            className="text-xs flex items-center"
            underline="hover"
          >
            {i18n.t("links.columns.time_series", {
              ns: "tables",
              defaultValue: "Time Series",
            })}
          </ExternalLink>
          <Link
            href={`${window.location.pathname}/${id}`}
            className="text-xs"
            underline="hover"
          >
            {i18n.t("actions.edit")}
          </Link>
        </div>
      );
    },
  },
];
